import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import lodashCompact from 'lodash/fp/compact';

import SrText from 'client/components/SrText';
import SrCardOld from 'client/components/SrCardOld';

class SrHowDoILeaseListingSection extends Component {
  static propTypes = {
    marketName: PropTypes.string,
    listingId: PropTypes.number,
    isSelfShowing: PropTypes.bool,
    onPrequalClick: PropTypes.func,
    onRequestTourClick: PropTypes.func,
    onUnlockDoorClick: PropTypes.func,
  }

  _onStartApplicationClick = () => {
    const { listingId } = this.props;
    if (!listingId) {
      return;
    }
    const element = document.getElementById('scrollHereForPrequal');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    const {
      isSelfShowing,
      listingId,
      marketName,
      onPrequalClick,
      onRequestTourClick,
      onUnlockDoorClick,
    } = this.props;

    const sectionRows = lodashCompact([
      {
        onClick: onPrequalClick,
        heading: '1. Complete Prequal Quiz',
        icon: 'emoji-checkmark-green-3x.png',
        label: (
          'Answer a few basic questions and we’ll let you know if you’re ' +
          'eligible to rent the property.'
        ),
      },
      !isSelfShowing && {
        onClick: onRequestTourClick,
        heading: '2. Request a Tour',
        icon: 'emoji-key-3x.png',
        label: (
          'View the property with our tour guides. Request a time ' +
          'that works for you.'
        ),
      },
      isSelfShowing && {
        onClick: onUnlockDoorClick,
        heading: '2. Unlock the Door',
        icon: 'emoji-key-3x.png',
        label: (
          'This home has self-showing looks so you can go on your own, ' +
          'any time 8am to 8pm.'
        ),
      },
      {
        onClick: listingId ? this._onStartApplicationClick : null,
        heading: '3. Apply Online',
        icon: 'emoji-papers-3x.png',
        label: (
          'Start your application and upload documents. Our team is here if ' +
          'you need any assistance!'
        ),
      },
    ]);

    return (
      <div className='SrHowDoILeaseListingSection'>
        <SrCardOld>
          <div className='cornerIcon' />
          <div className='inner'>
            <SrText
              size='2xl'
              leading='2xl'
              weight='bold'
              display='block'
              className='headline'
            >
              How do I lease this property?
            </SrText>
            <SrText
              size='medium'
              weight='bold'
              display='block'
              font='whitney-sc'
              className='subheading'
            >
              {`${marketName || 'Sunroom'} rental process`}
            </SrText>
            {sectionRows.map(({ onClick, heading, icon, label }, index) => (
              <div
                key={heading}
                className={classnames('sectionRow', index === 0 && 'first')}
              >
                <div className='icon' style={{ backgroundImage: `url(/images/${icon})` }} />
                <div>
                  <div>
                    <SrText
                      onClick={onClick}
                      color={onClick ? 'blue300' : null}
                      decoration={onClick ? 'underline' : null}
                      cursor={onClick ? 'pointer' : null}
                      size='large'
                      weight='medium'
                      className={onClick ? 'headerWithBlueArrow' : null}
                    >
                      {heading}
                    </SrText>
                  </div>
                  <SrText
                    size='medium'
                    leading='20'
                  >
                    {label}
                  </SrText>
                </div>
              </div>
            ))}
          </div>
        </SrCardOld>
      </div>
    );
  }
}

SrHowDoILeaseListingSection.displayName = 'SrHowDoILeaseListingSection';

export default SrHowDoILeaseListingSection;
